<template>
  <div class="ticketMemoTables">
    <div class="listTblCon">
      <table :class="{listTbl: true, 'btNone': !ticketHistory.length }">
        <colgroup>
          <col style="width:200px" />
          <col />
          <col style="width:180px" />
        </colgroup>
        <thead>
        <tr>
          <th>作成者</th>
          <th>内容</th>
          <th>作成日</th>
        </tr>
        </thead>
      </table>
      <div class="scrollList">
        <table class="listTbl" v-if="ticketHistory.length > 0">
          <colgroup>
            <col style="width:200px" />
            <col />
            <col style="width:180px" />
          </colgroup>
          <tbody>
          <tr v-for="(item, index) in ticketHistory" :key="index">
            <td>{{item.modifyBy || '-'}}</td>
            <td>{{ item.memo || '-' }}</td>
            <td v-html="convert(item.createDate)"></td>
          </tr>
          </tbody>
        </table>
        <div class="UXnotData" style="height:490px" v-if="ticketHistory.length === 0">
         メモ履歴がありません。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@/event_bus'
import event from '../enums/eventType'
import Helpers from '@/util/helpers'

export default {
  name: 'ticket_memo_history_dialog',
  data: () => ({
    headers: [
      {text: '作成者', align: 'center', value: 'modifyBy', sortable: false, width: 200},
      {text: '内容', align: 'center', value: 'memo', sortable: false, width: 530},
      {text: '作成日', align: 'center', value: 'createDate', sortable: false, width: 180}
    ],
    ticketHistory: [],
    pagination: {}
  }),
  mounted () {
    eventBus.$on(event.OPEN_TICKET_MEMO_HISTORY_DIALOG, (ticketId) => {
      this.historyTicket(ticketId)
    })
  },
  beforeDestroy () {
    eventBus.$off(event.OPEN_TICKET_MEMO_HISTORY_DIALOG)
  },
  created () {
    this.pagination.rowsPerPage = 5
  },
  methods: {
    convert (dateTime) {
      return `<div class="dateCor">${Helpers.convertDateYyyyMmDd(dateTime)}<br /><span>${Helpers.printTimeStampFromDateTimeWithoutAP(dateTime)}</span></div>`
    },
    historyTicket (ticketId) {
      this.axios.get('/gateway/ticket/history?ticketId=' + ticketId)
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data
            this.pagination.totalItems = data.length
            let ticketHistorys = []
            data.forEach(ticket => {
              let item = {modifyBy: ticket.modifyBy, memo: ticket.memo, createDate: ticket.createDate}
              ticketHistorys.push(item)
            })
            this.ticketHistory = ticketHistorys
          }
        })
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
        return 0
      }
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  }
}
</script>

<style lang="scss">
.ticketMemoTables {
  position: relative;
  padding-bottom: 30px;
  .scrollList {
    max-height:500px;
    overflow-y: auto;
    border-bottom: 1px solid $gray-3;
    .listTbl {
      border-bottom: none !important;
    }
  }
  .btNone {
    border-bottom: none !important;
  }
  .listTbl {
    border-bottom: none !important;
    tr {
      th {
        background: #EBEBEB;
        border-top: 1px solid #E5E5E5;
        border-bottom: 1px solid #E5E5E5;
      }
      td {
        border-top:0;
        border-bottom: 1px solid #E5E5E5;
        padding:7px;
        height:55px;
        .clampTxt {
          max-width: 100%;
        }
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticket_memo_history_dialog.vue